<template>
  <div id="against">
    <mt-header class="dl_header_new_bg" fixed v-if="type == 'back'">
      <mt-button slot="left" @click.native="$router.back()">
        <img class="go-back" src="@/assets/img/ico_back.png" />
      </mt-button>
    </mt-header>
    <div class="container" :class="type == 'back' ? '' : 'no-padding'">
      <h2  class="page-title" v-if="type == 'back'">{{ $t("swap.title") }}</h2>
      <div class="content">
        <div class="againstMain">
          <div class="wx_fontSize2 title-wrap">
          <div>  {{ $t("swap.pay") }}</div>
            <div class="title-price"><div>{{ $t("swap.balance") }}</div><div >{{ price }} {{ Fcoin_symbol }} </div></div>
          </div>
          <div class="top_main wx_fontSize2">
            <input
              type="text"
              :placeholder="$t('swap.input')"
              v-model="FromMount"
               style="border: 1px solid #cccccc;border-radius: 6px;height: 48px;box-shadow: 2px 2px 6px rgba(0,0,0,0.1) inset;background: #fcfcfc;font-weight: bold;"
            />
            <span @click="fromList('from')">
              <img v-bind:src="img_url" alt="" class="mark" />
              <span class="value wx_fontSize3">{{ Fcoin_symbol }}</span>
              <img
                src="../../assets/img/coinDetail/ico_gengduo.png"
                alt=""
                class="mark back"
              />
            </span>
          </div>
          <div v-show="isShow">
            <p class="wx_fontSize2">{{ $t("swap.lock_rate") }}</p>
            <p class="wx_fontSize2" style="margin-top: 16px">
              1{{ Fcoin_symbol }} = {{ rate | numFilter }}{{ Tcoin_symbol }}
              <span
                style="color: #1296db; left: 40%; font-weight: bold"
                class="wx_fontSize2"
                v-if="count >= 10"
                >00:00:{{ count }}</span
              >
              <span
                style="color: #1296db; left: 40%; font-weight: bold"
                class="wx_fontSize2"
                v-else
                >00:00:0{{ count }}</span
              >
            </p>
          </div>
        </div>
        <img
          src="../../assets/img/coinDetail/img_duihuan_duihuan.png"
          alt=""
          class="zhuanhuan"
          @click="exchange()"
        />
        <div class="againstMain">
          <div class="wx_fontSize2 title-wrap" style="margin-top: 0">
<div>            {{ $t("swap.gain") }}</div>
          </div>
          <div class="top_main wx_fontSize2">
            <input
              type="text"
              placeholder="--.--"
              :value="toMount"
              readonly="readonly"
            />
            <span @click="fromList('to')">
              <img v-bind:src="Timg_url" alt="" class="mark" />
              <span class="value wx_fontSize3">{{ Tcoin_symbol }}</span>
              <img
                src="../../assets/img/coinDetail/ico_gengduo.png"
                alt=""
                class="mark back"
              />
            </span>
          </div>
        </div>
        <p class="detail wx_fontSize1">{{ $t("swap.tip") }}</p>
		<!-- <div class="checkboxs">
			<span class="checkbox"></span>
			<div class="text">
				<span>将本次获得的2UT全额加入到理财中，加入后可获得股票兑换机会。</span>
			</div>
		</div> -->
        <!-- <div class="dl_margin1_top" v-if="Tcoin_symbol == '2UT'">
          <input
            type="checkbox"
            class="dl_margin1_right"
            v-model="isChecked"
            id="checknotice"
          />
          <label for="checknotice" class="font-bold"
            >{{ $t("swap.notice_2ut")
            }}<a
              href="https://www.auwallet.io/2ut_notice.pdf"
              style="color: #1296db !important"
              target="_blank"
            >
              Brighsun Limited Prospectus</a
            ></label
          >
        </div> -->
        <div
          class="footer dl_margin3_top wx_fontSize3"
          v-bind:class="'footer' + (isChecked ? '1' : '1')"
          @click="exchangeOrder()"
        >
          {{ $t("swap.submit") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { numFilter } from "@/filters/index";
import {
  httpFromCoins,
  httpToCoins,
  httpExchangeCheck,
  httpExchangeOrder,
  httpExchangePay,
} from "@/api/index";
import { validateEmpty } from "@/utils/validate";
export default {
  data() {
    return {
      Fcoin_symbol: "",
      Tcoin_symbol: "",
      price: "",
      id: "",
      img_url: "",
      Timg_url: "",
      FromMount: "",
      rate: "",
      isShow: false,
      toMount: "",
      count: "",
      timer: null,
      median: "",
      currentUrl: "",
      Tpirce: "",
      currentPrice: "",
      isChecked: false,
    };
  },
  activated() {
    this.toMount = "";
    this.FromMount = "";
    // if (this.$route.query.from_mount) {
    //     this.FromMount = this.$route.query.from_mount;
    //   }
    if (this.$route.query.coin_symbol && !this.$route.query.result) {
      this.Fcoin_symbol = this.$route.query.coin_symbol;
      this.price = this.$route.query.price;
      this.img_url = this.$route.query.img_url;
      // this.FromMount = this.$route.query.from_mount;
      if(this.$route.query.coin_symbol == 'USDT'){
        this.formList();
      }
      this.toList();
    } else if (!this.$route.query.coin_symbol && !this.$route.query.result) {
      this.formList();
    } else {
      if (this.$route.query.result.access == "from") {
        this.id = this.$route.query.result.id;
        this.Fcoin_symbol = this.$route.query.result.name;
        this.img_url = this.$route.query.result.img_url;
        this.price = this.$route.query.result.cloud_balance;
      } else {
        this.id = this.$route.query.result.id;
        this.Tcoin_symbol = this.$route.query.result.name;
        this.Timg_url = this.$route.query.result.img_url;
        this.Tpirce = this.$route.query.result.cloud_balance;
      }
    }
    // this.formList();
  },
  watch: {
    FromMount(val) {
      // 限制输入金额不能超过余额
      if (parseFloat(val) > parseFloat(this.price)) {
        this.FromMount = this.price;
        Toast("兑换金额不能超过余额");
      }
      
      if (val == "") {
        this.isShow = false;
        clearInterval(this.timer);
        this.toMount = "";
        return;
      } else {
        clearInterval(this.timer);
        this.timer = null;
        this.getCode();
      }
    },
    count(val) {
      if (val == 0) {
        clearInterval(this.timer);
        this.timer = null;
        this.getCode();
      }
    },
    isChecked(val) {
      return val;
    },
  },

  props:{
	type:{
		type:String,
		default:'back'
	}
  },
  deactivated() {
    clearInterval(this.timer);
  },
  methods: {
    fromList(access) {
      this.$router.push({
        path: "/coinAgaList",
        query: { access: access, coin_symbol: this.Fcoin_symbol },
      });
    },
    formList() {
      httpFromCoins({})
        .then((res) => {
          this.Fcoin_symbol = res.data.list[0].coin_symbol;
          this.price = res.data.list[0].cloud_balance;
          this.img_url = res.data.list[0].img_url;
          this.toList();
        })
        .catch(() => {});
    },
    toList() {
      httpToCoins({ from_coin: this.Fcoin_symbol })
        .then((res) => {
          if (res.code == 1) {
            this.Tcoin_symbol = res.data.list[0].coin_symbol;
            this.Timg_url = res.data.list[0].img_url;
            this.Tpirce = res.data.list[0].cloud_balance;
          } else {
            Toast("暂无数据");
          }
        })
        .catch(() => {});
    },
    exchangeCheck(type) {
      if (
        validateEmpty(this.Fcoin_symbol) ||
        validateEmpty(this.Tcoin_symbol)
      ) {
        Toast(this.$t("empty"));
        return;
      }
      if (type == 1) {
        var p = { from_coin: this.Tcoin_symbol, to_coin: this.Fcoin_symbol };
      } else if (type == 0) {
        var p = { from_coin: this.Fcoin_symbol, to_coin: this.Tcoin_symbol };
      }
      httpExchangeCheck(p)
        .then((res) => {
          if (res.code == 1) {
            if (type == 0) {
              this.isShow = true;
            } else if (type == 1) {
              this.median = this.Tcoin_symbol;
              this.Tcoin_symbol = this.Fcoin_symbol;
              this.Fcoin_symbol = this.median;
              this.currentUrl = this.Timg_url;
              this.Timg_url = this.img_url;
              this.img_url = this.currentUrl;
              this.currentPrice = this.Tpirce;
              this.Tpirce = this.price;
              this.price = this.currentPrice;
            }
            this.rate = res.data.rate;
            var formStr = numFilter(this.FromMount);
            var rate = numFilter(this.rate);
            this.toMount = formStr * rate;
          } else {
            Toast(res.msg);
          }
        })
        .catch(() => {});
    },
    exchangeOrder() {
		console.log('do this --')
      if (
        validateEmpty(this.Fcoin_symbol) ||
        validateEmpty(this.Tcoin_symbol) ||
        this.FromMount == ""
      ) {
        Toast(this.$t("empty"));
        return;
      }
	  //判断币种和金额
	  if(this.Fcoin_symbol == 'USDT' && this.Tcoin_symbol == 'U2U'){
		  if(this.FromMount % 100 !== 0){
			  Toast(this.$t("against.no100"));
			  return false;
		  }
	  }
	  
	  // 判断MMT兑换数量限制
	  if(this.Tcoin_symbol == 'MMT'){
	    if(this.toMount < 10){
	      Toast("MMT最少兑换10个");
	      return false;
	    }
	    if(this.toMount > 10000){
	      Toast("MMT最多兑换10000个");
	      return false;
	    }
	  }
	  
      var p = {
        from_coin: this.Fcoin_symbol,
        to_coin: this.Tcoin_symbol,
        amount: this.FromMount,
      };
      httpExchangeOrder(p)
        .then((res) => {
          if (res.code == 1) {
            this.exchangePay(res.data.order_id);
          } else {
            Toast(res.msg);
          }
        })
        .catch(() => {});
    },
    exchangePay(order_id) {
      var p = {
        order_id: order_id,
      };
      httpExchangePay(p)
        .then((res) => {
          Toast(res.msg);
          if (res.code == 1) {
            //如果目标token是MMT,则跳转到抽奖页面
            this.$router.back();
            return false;
            //if(this.Tcoin_symbol == 'MMT'){
              //this.$router.push({
                //path: "/lottery",
                //query: { orderid: res.data.order_id }
              //});
            //}else{
              //this.$router.back();
            //}
          }
        })
        .catch(() => {});
    },
    getCode() {
      this.exchangeCheck(0);
      const TIME_COUNT = 30;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count = this.count - 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } else {
      }
    },
    exchange() {
      this.exchangeCheck(1);
    },
  },
};
</script>

<style scoped>
*{
	box-sizing: border-box;
}
.checkboxs{
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
}
.checkbox{
	width: 20px;
	height: 20px;
	border: 2px solid #999999;
	border-radius: 4px;
	display: block;
}
.text{
	width: calc(100% - 30px);
	font-size: 14px;
}
#against {
  width: 100%;
  background-color: #f6f8fa;
  height: 100%;
}
.go-back {
  width: 20px;
  height: 20px;
}

.no-padding .page-title{
    margin-top: 0;
}
.page-title {
  margin-top: 60px;
  font-size: 1.25rem;
  font-weight: 600;
  color: #12172e;
}
.container {
  padding: 10px 30px;
  background-color: #f6f8fa;
}
.container.no-padding{
    padding: 0 30px;
}


.content {
  background: #f6f8fa;
  padding-top: 30px;
  height: 100%;
}

.no-padding .content{
    padding-top: 0 !important;
}
.againstMain {
  background: #fff;
  padding: 20px 15px;
  box-shadow: 0 20px 15px 8px #dae5f0;
  border-radius: 20px;
  display:flex;
  flex-direction: column;
  height: fit-content;
}
.againstMain div {
  color: #12172E;
  width: 100%;
  font-weight: 500;
  position: relative;
}

.againstMain .left-title{
    width: fit-content;
}
.againstMain .title-wrap{
    display: flex;
 
}

.title-price{
    margin-left: auto;
    display: flex;
    width: fit-content;
    justify-content: flex-end;
}
.againstMain div div {
  color: #8c92a8;

  font-weight: normal;
  display: flex;
  width: fit-content;
  flex-direction: column;
}
.top_main {
  width: 100%;
  background: #fff;
  height: fit-content;
  border-radius: 5px;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.top_main input {
    flex:1 1 calc(40% - 10px);

  display: flex;
  height: 68px;
  line-height: 68px;
  text-indent: 1em;
  border-right: 2px solid #f6f6f6;
  color: #212529;
}
.top_main input::placeholder {
  color: #A9AFBD!important;
  font-size: 0.875rem;
}
.top_main span {
    flex:1 1 calc(40% - 10px);
padding-left: 10px;
  display: flex;
  line-height: 68px;
  align-items:center;
}
.top_main span .mark {
  width: 30px;
  height: 30px;

}
.top_main span .value {
  color: #212529;
  margin-left: 10px;

}
.top_main span .back {
  width: 10.5px;
  height: 18px;

}
.zhuanhuan {
  width: 19px;
  height: 19px;
  margin: 18px calc(50% - 9.5px);
}
.detail {
  padding:30px 20px;
  width: 100%;
  color: #828590;
  font-weight: 400;
}
.footer1 {
  width: calc(100% - 30px);
  height: 50px;
  background: #2BB0E9;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  border-radius: 50px;
  pointer-events: auto;
  margin:  10px auto;
}
.footer2 {
  width: calc(100% - 30px);
  height: 50px;
  background: #E4E9EE;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  border-radius: 50px;
  pointer-events: none;
  margin:  10px auto;
}
</style>